import styled from 'styled-components'
export const StyledTable = styled.table`
  width: 100%;

  th {
    border-left: 1px solid #e2e2e2;
    border-right: 1px solid #e2e2e2;
    padding: 8px;
  }

  td {
    padding: 8px;
  }

  thead > tr {
    background-color: #e2e2e2;
  }

  tbody > tr {
    cursor: pointer;

    border-top: 1px solid #e2e2e2;
    border-bottom: 1px solid #e2e2e2;

    &:nth-child(odd) {
      background-color: #ffffff;
    }

    &:nth-child(even) {
      background-color: #f2f2f2;
    }

    &:hover {
      background-color: #e2e2e2;
    }

    &.locked {
      background-color: rgb(255, 192, 203);
    }

    td {
      border-left: 1px solid #e2e2e2;
      border-right: 1px solid #e2e2e2;
      &:nth-child(1) {
        width: 30%;
      }

      &:nth-child(2) {
        width: 30%;
      }

      &:nth-child(3) {
        width: 30%;
      }
    }
  }
`
